var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgStepBefore = function SvgStepBefore(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "navigation-left-circle-1_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,12A12,12,0,1,0,12,24,12.013,12.013,0,0,0,24,12ZM10.293,17.2l-4.5-4.5a1,1,0,0,1,0-1.414l4.5-4.5a1,1,0,1,1,1.414,1.414L9.341,10.571A.25.25,0,0,0,9.518,11H18a1,1,0,0,1,0,2H9.518a.25.25,0,0,0-.177.426l2.366,2.367A1,1,0,0,1,10.293,17.2Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStepBefore);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/step-before.bd126b2b7cffe454d8488e10c5129687.svg";